import { useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  Button,
  Badge,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import Phone from "@mui/icons-material/Phone";
import ShoppingCart from "@mui/icons-material/ShoppingCart";
import { useCart } from "../../context/CartContext";

const NavMenu = () => {
  const [open, setOpen] = useState(false);
  const { itemCount } = useCart();

  return (
    <>
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: "#3b519d" }}>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyItems: "space-between",
              justifyContent: "space-between",
            }}
          >
            <Box></Box>
            {/* <Box
              sx={{
                display: "flex",
                pl: 2,
                bgcolor: "#222e56",
                "&:hover": { bgcolor: "#19203d", cursor: "pointer" },
              }}
            >
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="phone"
              >
                <Phone />
              </IconButton>

              <Typography
                to="tel:505-555-4444"
                variant="contained"
                component={RouterLink}
                sx={{
                  bgcolor: "#222e56",
                  color: "#fff",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&:hover": { bgcolor: "#19203d", cursor: "pointer" },
                  py: 2,
                  pr: 4,
                }}
              >
                505-555-4444
              </Typography>
            </Box> */}

            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                "&:hover": { bgcolor: "#19203d", cursor: "pointer" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  pl: 2,
                  bgcolor: "#3b519d",
                  "&:hover": { bgcolor: "#19203d", cursor: "pointer" },
                }}
              >
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="cart"
                  component={RouterLink}
                  to="/cart"
                >
                  {/* ← only change here: wrap the icon */}
                  <Badge
                    badgeContent={itemCount}
                    color="primary"
                    showZero
                    max={999}
                  >
                    <ShoppingCart />
                  </Badge>
                </IconButton>

                <Typography
                  to="/cart"
                  variant="contained"
                  component={RouterLink}
                  sx={{
                    bgcolor: "#3b519d",
                    color: "#fff",
                    fontWeight: "bold",
                    textDecoration: "none",
                    "&:hover": { bgcolor: "#19203d", cursor: "pointer" },
                    py: 2,
                    pr: 4,
                  }}
                >
                  Cart
                </Typography>
              </Box>

              <Typography
                to="/contact"
                variant="contained"
                component={RouterLink}
                sx={{
                  bgcolor: "#222e56",
                  color: "#fff",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&:hover": { bgcolor: "#19203d", cursor: "pointer" },
                  py: 2,
                  px: 4,
                }}
              >
                Contact Us
              </Typography>

              <Typography
                to={"/reorder"}
                variant="contained"
                component={RouterLink}
                sx={{
                  bgcolor: "#dca026",
                  color: "#000",
                  fontWeight: "bold",
                  textDecoration: "none",
                  "&:hover": { bgcolor: "#c6941f", cursor: "pointer" },
                  py: 2,
                  px: 4,
                }}
              >
                Reorder
              </Typography>
            </Box>

            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                color="inherit"
                onClick={() => setOpen(true)}
                aria-label="menu"
              >
                <MenuIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </AppBar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{ width: 240 }}
          role="presentation"
          onClick={() => setOpen(false)}
        >
          <List>
            <ListItem>
              <Button
                component={RouterLink}
                to="/contact"
                fullWidth
                sx={{ bgcolor: "#222e56", color: "#fff" }}
              >
                Contact Us
              </Button>
            </ListItem>
            <ListItem>
              <Button
                component={RouterLink}
                to="/reorder"
                fullWidth
                sx={{ bgcolor: "#dca026", color: "#000" }}
              >
                Reorder
              </Button>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default NavMenu;
